<template>
    <fe-dialog
        title="Link SLO"
        @dismiss="localValue=false; selectedType=null"
        @accept="linkFormTo"
        v-if="localValue"
        :width="width"
        :acceptButtonDisabled="!linkRecord"
        dismissButtonText="Cancel"
        acceptButtonText="Link SLO"
        persistent
    >
        <div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th v-for="c in columns">
                                {{ c.header }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;" v-for="item in lookupItems" :key="item.name" @click="linkRecord = item" :class="{selected: linkRecord == item}">
                            <td v-for="c in columns">
                                {{ item[c.field] }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
        <div v-if="!lookupItems.length">
            No SLOs to link.
        </div>
    </fe-dialog>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'LinkForm',
        props: {
            value: {

            },
            rec: {
                required: true
            },
        },
        computed: {
            ...mapState('global', ['sessionUser']),
        },
        watch: {
            value(v) {
                this.localValue = v
                if (v) {
                    this.selectedType = 'slo'
                    this.types.find(x => x.id === 'slo').handler()
                }
            },
            localValue(v) {
                this.$emit('input', v)
            },
            selectedType() {
                this.width = 700
            },
        },
        data() {
            let me = this
            return {
                selectedType: null,
                localValue: null,
                lookupItems: [],
                linkRecord: null,
                width: 600,
                columns: [],
                types: [{
                    id: 'slo',
                    name: 'SLO',
                    handler() {
                        me.selectedType = 'slo'
                        let url = 'sloPlanV.php?action=get&slo_user_user_id='+me.sessionUser.user.id
                        me.$axios.get(url)
                            .then(response => {
                                me.columns = [{
                                    header: 'SLO Name',
                                    field: 'slo_name'
                                }, {
                                    header: 'Reviewer',
                                    field: 'slo_approval_user_display_name'
                                }, {
                                    header: 'Created',
                                    field: 'slo_created'
                                }]

                                me.lookupItems = response.data.plans
                            })
                    }
                }]
            }
        },
        mounted() {
            this.localValue = this.value
            this.selectedType = 'slo'
            this.types.find(x => x.id === 'slo').handler()
        },
        methods: {
            linkFormTo() {
                let p = {
                    link_type: this.selectedType,
                    form_instance_id: this.rec.form_instance_id,
                    property: 'form_link',
                    action: 'create'
                }
                p.link_id = this.linkRecord.slo_id
                this.linkOther('form.php?action=create&', p)
            },
            linkOther(url, p) {
                this.$axios.post(url+'&'+this.$objectToParams(p))
                    .then(response => {
                        this.$ecResponse(response)
                    })
                    .finally(() => {
                        this.localValue = false
                        this.selectedType = null
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
.selected {
    background-color: var(--fe-accent);
}

.row-item {
    &:hover {
        background-color: var(--fe-accent);
        text-shadow: 0.5px 0 0 #050F2D;
    }
}

</style>
